import _ from "lodash";

import { Api } from "@api/index";
import { ModelSelectStateProps, ModelSelectOuterProps, makeModelSelectComponent } from "@api/components/ModelSelect";
import { AuthState } from "@auth/models";
import { getInitialState as authInitialState } from "@auth/reducers";
import { FilesState } from "@files/models";
import { getInitialState as filesInitialState } from "@files/reducers";
import { MusicState, Track } from "../../models";
import { getInitialState } from "../../reducers";
import { makeHydrateTrack, makeGetTracks } from "../../selectors";
import { NormalisedEntities } from "@app/modules/orm/models";

type State = MusicState & FilesState & AuthState;

const makeMapStateToProps = () => {
    const getTracks = makeGetTracks();
    return (state: State, props: ModelSelectOuterProps<Track>) => {
        const trackProps = {
            tracks: [] as Track[],
        };
        if (Array.isArray(props.selected)) {
            trackProps.tracks = _.map(props.selected, (id: number) => new Track({id}));
        }
        else if (props.selected != null) {
            trackProps.tracks = [new Track({id: props.selected})];
        }
        return {
            selectedModels: getTracks(state, trackProps),
        } as ModelSelectStateProps<Track>;
    };
};

const { presenter, connected } = makeModelSelectComponent<Track, State>(
    "track-select",
    ({ id }: Track) => String(id),
    (track: Track) => track.artistsStr
        + " - " + track.title
        + (track.isrc ? " (" + track.isrc + ")" : ""),
    Api.tracksSearch,
    (entities: NormalisedEntities) => {
        const files = {
            ...filesInitialState().entities,
            ...entities,
        };
        const auth = {
            ...authInitialState().entities,
            ...entities,
        };
        const music = {
            ...getInitialState().entities,
            ...entities,
        };
        return makeHydrateTrack(music, files, auth);
    },
    makeMapStateToProps,
);

export {
    presenter as TrackSelectPresenter,
    connected as TrackSelect,
};
